import { axInstBasic } from "../../components/Service/Service";

export const cacAndCsrProblem = async (searchData) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}cacAndCsrProblem`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};